import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export var branchListRes;
export const branchListTodo = createAsyncThunk('branchList', async (data) => {
    // console.log("data", data)
    try {
        const res = await axios({
            method: "post",
            url: process.env.REACT_APP_API_URL + 'branches',
            headers: { "Content-Type": "application/json" },
            data:{
                "status":data ? data :''
            }
        })
        return branchListRes = res.data

    } catch (error) {
        return branchListRes = error.response.data
    }
});

const branchListSlice = createSlice({
    name: 'branchList',
    initialState: {
        data: null,
    },
    extraReducers: (builder) => {
        builder.addCase(branchListTodo.fulfilled, (state, action) => {
            state.data = action.payload;
            // console.log('userList', state.data)
        });
        builder.addCase(branchListTodo.rejected, (state, action) => {
            // console.log('token_error', action)
        })
    }
});

export default branchListSlice.reducer; 